// extracted by mini-css-extract-plugin
export default {"footer-section":"footer-section--l0KG+","footerSection":"footer-section--l0KG+","link":"link--OokSu","title":"title--sCJcj"};